import React from 'react';
import { Avatar, Box, CardHeader, useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import { ActiveMember, Role, UserRolesInput } from '../types/members-types';
import UpdateUserRolesForm from './UpdateUserRolesForm';
import { Nullable } from 'common-types';

interface IUpdateRolesModalProps {
  open: boolean;
  member: Nullable<ActiveMember>;
  onClose: () => void;
  onAddRole: (userRolesInput: UserRolesInput) => void;
  onRemoveRole: (userRolesInput: UserRolesInput) => void;
  availableRoles: Role[];
}

const UpdateRolesModal: React.FC<
  React.PropsWithChildren<IUpdateRolesModalProps>
> = props => {
  const theme = useTheme();

  const { open, onClose, member, onAddRole, onRemoveRole, availableRoles } =
    props;

  if (!member) {
    return null;
  }

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Update member roles'
      open={open}
      onClose={onClose}
      modalHeader='Update member roles'>
      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <CardHeader
          avatar={<Avatar alt={member.name} src={member.picture} />}
          title={member.name}
          subheader={member.email}
        />
      </Box>
      <UpdateUserRolesForm
        member={member}
        onAddRole={onAddRole}
        onRemoveRole={onRemoveRole}
        availableRoles={availableRoles}
      />
    </ModalDialog>
  );
};

export default UpdateRolesModal;
